import { render, staticRenderFns } from "./PixelScriptsRegistro.vue?vue&type=template&id=21e98c72&"
import script from "./PixelScriptsRegistro.vue?vue&type=script&lang=js&"
export * from "./PixelScriptsRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports